<template>
  <section>
    <qx-tab :tabs="tabs" v-model="activeTab" />
    <Bill ref="detail" v-show="activeTab === '1'" />
    <Expire ref="operate" v-show="activeTab === '2'" />
  </section>
</template>

<script>
import Bill from './bill/bill.vue';
import Expire from './expire/expire.vue';
export default {
  components: {
    Bill,
    Expire,
  },
  data () {
    return {
      activeTab: '1',
      tabs: [
        {
          label: '车主账单明细',
          value: '1',
        },
        {
          label: '未到期明细',
          value: '2',
        },
      ],
    };
  },
};
</script>

<style>
</style>
